import React from 'react';
import { ALLPAGOPAYPAL } from 'researcher/domain/transaction/payment-method';
import TaxIdentificationForm, { initialState as taxIdentificationInitialState } from './TaxIdentificationForm';
export var defaultValues = taxIdentificationInitialState;
var AllpagoPaypalForm = function AllpagoPaypalForm(_ref) {
  var paymentMethodId = _ref.paymentMethodId;
  if (paymentMethodId !== ALLPAGOPAYPAL) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(TaxIdentificationForm, {
    name: "allpagoPaypal"
  }));
};
export default AllpagoPaypalForm;